import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user-page-layout"
};
const _hoisted_2 = {
  class: "lay-header"
};
const _hoisted_3 = {
  class: "header-extra-wrapper"
};
const _hoisted_4 = {
  class: "header-extra"
};
const _hoisted_5 = {
  class: "page-header"
};
const _hoisted_6 = {
  class: "page-content"
};
import { useRoute, useRouter } from 'vue-router';
import { MgAuthorMenu, modal } from '@/share/components';
import { useAuthorStore, useMyOrgStore, useUserRouterStore } from '@/stores';
import { useChangeSelfPwdModal } from '@/share/hooks/common';

import { computed } from 'vue';
export default {
  __name: 'mul-page-layout',
  props: {
    authorMenu: {
      type: Array
    }
  },
  emits: ['author-avatar-click', 'author-menu-click'],
  setup(__props, {
    emit: __emit
  }) {
    const router = useRouter();
    const route = useRoute();
    const authorStore = useAuthorStore();
    const myOrgStore = useMyOrgStore();
    const userRouterStore = useUserRouterStore();
    const {
      showChangeSelfPwdModal
    } = useChangeSelfPwdModal();
    const emit = __emit;
    const pageTitle = computed(() => {
      const {
        meta: {
          title = '标题'
        }
      } = route;
      return title;
    });
    const handleGoHome = () => {
      router.push({
        path: '/index'
      });
    };
    const handleGoBack = () => {
      router.go(-1);
    };
    const handleAuthorAvatarClick = () => {
      emit('author-avatar-click');
    };
    async function quitSystem() {
      const cfm = await modal.confirm('退出确认', '您确认要退出系统吗？');
      if (!cfm) return Promise.resolve(false);
      authorStore.$reset();
      myOrgStore.$reset();
      userRouterStore.setRouterIsReady(false);
      return router.push({
        path: '/login'
      });
    }
    const handleAuthorMenuClick = ({
      item,
      user,
      $event
    }) => {
      const {
        name
      } = item || {};
      switch (name) {
        case 'quit':
          quitSystem();
          break;
        case 'changeSelfPwd':
          showChangeSelfPwdModal();
          break;
      }
      emit('author-menu-click', {
        item,
        user,
        $event
      });
    };
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_breadcrumb_item = _resolveComponent("vxe-breadcrumb-item");
      const _component_vxe_breadcrumb = _resolveComponent("vxe-breadcrumb");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "kpi-header-title"
      }, [_createElementVNode("i", {
        class: "header-icon kpi-sys-logo"
      }), _createElementVNode("span", {
        class: "header-title"
      }, "爱绩效平台——绩效指标管理系统")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_renderSlot(_ctx.$slots, "header-extra")]), _createVNode(_unref(MgAuthorMenu), {
        id: "sys-author-menu",
        items: __props.authorMenu,
        onMenuClick: handleAuthorMenuClick,
        onAvatarClick: handleAuthorAvatarClick
      }, {
        "prefix-panel": _withCtx(({
          isOpen
        }) => [_renderSlot(_ctx.$slots, "author-menu-prefix", {
          isOpen: isOpen
        })]),
        "suffix-panel": _withCtx(({
          isOpen
        }) => [_renderSlot(_ctx.$slots, "author-menu-suffix", {
          isOpen: isOpen
        })]),
        _: 3
      }, 8, ["items"])])]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "header", {}, () => [_createVNode(_component_vxe_button, {
        icon: "vxe-icon-arrows-left",
        status: "success",
        size: "mini",
        onClick: handleGoBack
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("返回", -1)]))]),
        _: 1
      }), _createVNode(_component_vxe_breadcrumb, {
        style: {
          "margin-left": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_breadcrumb_item, {
          onClick: handleGoHome
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_button, {
            icon: "fa fa-home",
            mode: "text"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("首页", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_breadcrumb_item, {
          title: _unref(pageTitle)
        }, null, 8, ["title"])]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
        _: 1
      })]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "page-footer"
      }, [_createElementVNode("i", {
        class: "ui-icon icon-sys-logo"
      }), _createTextVNode(" 贵州码软件科技有限公司提供技术支持 ")], -1))]);
    };
  }
};